import React from 'react';
import { Row, Col } from 'react-bootstrap';
import "../componentCss/footer.css";

const Footer = ({ userDetails }) => {
  const user = userDetails?.[0] || {};

  return (
    <div className="footer-wrapper">
      <table className="footer-table">
        <tbody>
          <tr>
            <td className="footer-cell">
              <strong>User & Role:</strong>
              <div>{user.firstName} {user.lastName}</div>
            </td>
            <td className="footer-cell">
              <strong>License Number:</strong>
              <div>{user.licenceNumber || "NA"}</div>
            </td>
            <td className="footer-cell">
              <strong>Signature:</strong>
              <div>
                {user.signature ? (
                  <img
                    src={user.signature}
                    alt="Signature"
                    className="footer-img signature-img"
                  />
                ) : "NA"}
              </div>
            </td>
            <td className="footer-cell">
              <strong>Stamp:</strong>
              <div>
                {user.stampImage ? (
                  <img
                    src={user.stampImage}
                    alt="Stamp"
                    className="footer-img stamp-img"
                  />
                ) : "NA"}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="footer-generated">
        This report is generated by www.neurela.com on:{" "}
        {new Date().toLocaleDateString("en-GB")}{" "}
        {new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </div>
    </div>
  );
};

export default Footer;
